if (!customElements.get('nuki-size-guide')) {
  customElements.define('nuki-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.rows = JSON.parse(this.querySelector('[data-size-data]').textContent);
      this.dialog = this.querySelector('dialog');
      this.selected = 0;
      this.preview = 0;
      this.unit = 'cm';
      this.opening = null;
      this.addEventListener('click', e => {
        const size = e.target.closest('[data-guide-size]');
        const row = e.target.closest('[data-guide-row]');
        const unit = e.target.closest('[data-guide-unit]');
        const photo = e.target.closest('[data-photo-size]');
        if (size) { this.selected = Number(size.dataset.guideSize); this.render(); }
        if (row && !size) { this.selected = Number(row.dataset.guideRow); this.render(); }
        if (unit) { this.unit = unit.dataset.guideUnit; this.render(); }
        if (photo) { this.preview = Number(photo.dataset.photoSize); this.renderPhotos(); }
        if (e.target.closest('[data-close-guide]')) this.dialog.close();
        if (e.target.closest('[data-apply-size]')) this.apply();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.oldOverflow || '';
        const target = this.afterClose || this.opening;
        this.afterClose = null;
        if (target?.isConnected) target.focus({ preventScroll: true });
      }, { signal });
      this.dialog.addEventListener('keydown', e => {
        if (e.key !== 'Tab') return;
        const items = [...this.dialog.querySelectorAll('button:not(:disabled),[href],input:not(:disabled),[tabindex="0"]')].filter(el => el.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
      }, { signal });
      this.addEventListener('shopify:block:select', e => {
        const index = this.rows.findIndex(row => row.id === e.detail.blockId);
        if (index >= 0) { this.preview = index; this.renderPhotos(); }
      }, { signal });
      this.renderPhotos();
      this.render();
    }
    open(trigger) {
      this.opening = trigger;
      this.activeProduct = trigger.closest('clic35-product[data-product-url]') || document.querySelector('clic35-product[data-product-url]');
      this.fromBottom = this.contains(trigger);
      const active = this.product()?.querySelector('[data-nuki-size] input:checked')?.value;
      const mapped = this.rows.findIndex(row => row.variant && row.variant === active);
      this.selected = this.fromBottom ? this.preview : (this.dataset.confirmed === 'true' && mapped >= 0 ? mapped : 0);
      this.unit = 'cm';
      this.render();
      if (this.dialog.open) return;
      this.oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.querySelector('[data-close-guide]').focus();
    }
    product() { return this.activeProduct?.isConnected ? this.activeProduct : document.querySelector('clic35-product[data-product-url]'); }
    choice() {
      const root = this.product();
      const row = this.rows[this.selected];
      if (!root || !row || typeof root.loadVariant !== 'function' || this.dataset.confirmed !== 'true' || !row.variant) return {};
      const input = [...root.querySelectorAll('[data-nuki-size] input[data-option-id]')].find(el => el.value === row.variant);
      if (!input) return {};
      const values = [...root.querySelectorAll('[data-options] fieldset')].map(field => field.hasAttribute('data-nuki-size') ? row.variant : field.querySelector('input:checked')?.value);
      const variant = [...root.querySelectorAll('template[data-local-variant],template[data-guide-variant]')].find(el => JSON.stringify(JSON.parse(el.dataset.options)) === JSON.stringify(values));
      return { root, input, variant };
    }
    render() {
      const row = this.rows[this.selected];
      if (!row) return;
      this.querySelectorAll('[data-guide-size]').forEach(button => {
        const chosen = Number(button.dataset.guideSize) === this.selected;
        button.setAttribute('aria-pressed', String(chosen));
        button.closest('tr')?.classList.toggle('is-selected', chosen);
      });
      this.querySelectorAll('[data-guide-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideUnit === this.unit)));
      this.querySelectorAll('[data-table-value]').forEach(cell => {
        cell.textContent = this.rows[Number(cell.dataset.row)][this.unit][Number(cell.dataset.tableValue)];
      });
      this.querySelectorAll('[data-unit-label]').forEach(el => el.textContent = this.unit === 'cm' ? 'cm' : 'po');
      this.querySelectorAll('[data-mobile-value]').forEach(el => el.textContent = row[this.unit][Number(el.dataset.mobileValue)] + (this.unit === 'cm' ? ' cm' : ' po'));
      const choice = this.choice();
      const status = this.querySelector('[data-guide-status]');
      const unavailable = choice.variant && choice.variant.dataset.available !== 'true';
      this.querySelector('[data-apply-size]').disabled = !choice.input || !choice.variant || unavailable;
      status.textContent = !choice.input ? 'Sélectionnez votre taille directement dans les options du produit.' : (!choice.variant || unavailable ? 'Cette taille est indisponible dans le coloris sélectionné.' : '');
      status.hidden = !status.textContent;
    }
    renderPhotos() {
      this.querySelectorAll('[data-photo-size]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.photoSize) === this.preview)));
      this.querySelectorAll('[data-size-photo]').forEach(photo => photo.hidden = Number(photo.dataset.sizePhoto) !== this.preview);
    }
    async apply() {
      const { root, input, variant } = this.choice();
      if (!input || !variant || variant.dataset.available !== 'true') return;
      input.checked = true;
      const url = new URL(root.dataset.productUrl, location.origin);
      url.searchParams.set('option_values', [...root.querySelectorAll('[data-option-id]:checked')].map(el => el.dataset.optionId).join(','));
      this.querySelector('[data-apply-size]').disabled = true;
      try {
        await root.loadVariant(url, input.id, false);
        const target = document.getElementById(input.id);
        if (root.querySelector('.c35-form [name="id"]')?.value !== variant.dataset.variant || root.querySelector('[data-error]')?.textContent.trim()) return;
        this.afterClose = target;
        this.dialog.close();
        if (this.fromBottom) target?.closest('[data-nuki-size]')?.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        target?.focus({ preventScroll: true });
      } finally { this.render(); }
    }
    disconnectedCallback() {
      if (this.dialog?.open) { this.dialog.close(); document.documentElement.style.overflow = this.oldOverflow || ''; }
      this.controller?.abort();
      this.controller = null;
    }
  });

  let loadingGuide;
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-nuki-open-guide]');
    if (!trigger) return;
    event.preventDefault();
    let guide = trigger.closest('nuki-size-guide') || document.querySelector('nuki-size-guide');
    if (!guide) {
      const product = trigger.closest('clic35-product[data-product-url]');
      if (!product) return;
      trigger.setAttribute('aria-busy', 'true');
      try {
        loadingGuide ||= (async () => {
          const response = await fetch(product.dataset.productUrl, { credentials: 'same-origin' });
          if (!response.ok) throw new Error();
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = html.querySelector('nuki-size-guide');
          if (!source) throw new Error();
          source.querySelector('.ng-layout')?.remove();
          source.dataset.dialogOnly = 'true';
          document.body.append(source);
          return source;
        })();
        guide = await loadingGuide;
      } catch {
        loadingGuide = null;
        let error = product.querySelector('[data-nuki-guide-error]');
        if (!error) {
          error = document.createElement('p');
          error.dataset.nukiGuideError = '';
          error.setAttribute('role', 'alert');
          trigger.after(error);
        }
        error.textContent = 'Le guide n’a pas pu se charger. Réessayez.';
        return;
      } finally { trigger.removeAttribute('aria-busy'); }
    }
    trigger.closest('clic35-product')?.querySelector('[data-nuki-guide-error]')?.remove();
    guide.open(trigger);
  });
}
